module.exports = __webpack_public_path__ + "img/img2.a20e979f.png";